module.exports = __webpack_public_path__ + "static/img/10.3dc528a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/10.png
// module id = f/YB
// module chunks = 0